<template>
  <div class="main" id="main">
    <sdk-index></sdk-index>
    <iframe :src="src" ref="iframe" id="iframe" scrolling="auto" frameborder="0"></iframe>
  </div>
</template>

<script>
import { JSSDK } from "../h5sdk/jssdk";
import FN from "@/utility/fn";
import SdkIndex from "@/page/Index";
// import { Toast } from "mint-ui";
import { CLIENTSDK } from "../h5sdk/clientSdk"
// import { requestEncrypt, returnDecrypt } from "@/utility/fuse.auth";
import configUrl from '../utility/config.js'
import { thirdInit } from '../utility/thirdSdk.js'

import { mapMutations } from 'vuex'
export default {
  name: "Main",
  data() {
    return {
      src: "",
      // src: '',
      iframeWin: ""
    };
  },
  components: {
    SdkIndex
  },
  methods: {
    ...mapMutations(['UPDATE_IOS_GUIDE']),
    jsLoadAjax(params = {}) {
      let input = {
        ct: "h5",
        ac: "js_load",
        ...params
      }
      return FN.ajax('jsload', input, {
        domain: configUrl.__h5apiDomain.get("jsLoad")
      })
    },
    // 针对渠道需要加载多个js情况（如jquery）
    loadChannelJs (channel_js, callback) {
      // channel_js不为空时才加载
      if (channel_js !== "") {
        let list = channel_js.split(",");
        for (let i = 0; i < list.length; i++) {
          FN.inject(
            "head",
            list[i] + `?_cache=${new Date().valueOf()}`,
            "script"
          ).then(() => {
            if (list.length === i + 1) {
              callback();
            }
          });
        }
      } else {
        callback();
      }
    },
    jsLoad() {
      let urlParams = FN.getURLparams(); // 获取链接参数
      let params = {
        yisdk_param: decodeURIComponent(this.$route.params.yisdkParam || urlParams.yisdk_param || ""),
        ext_param: decodeURIComponent(this.$route.params.extParam || urlParams.ext_param || ""),
        sign: urlParams.sign || '' // 端嵌套web-view 投放
      }
      this.jsLoadAjax(params).then(res => {
        if (res.code === 0) {
          //  融合渠道信息存在缓存里面
          FN.saveSession("FUSE_CHANNEL_INFO", res.data);
          FN.saveLocal("FUSE_CHANNEL_INFO", res.data);
          window.FUSE_CHANNEL_INFO = res.data;
          // 设置标题
          document.title = res.data.game_name;
          // 获取链接参数
          let { channel_js, channel, game_id, game_url, pf_game_id } = res.data;
          // 初始化第三方sdk
          thirdInit(game_id, pf_game_id)
          if (game_url.indexOf('?') === -1) {
            game_url = `${game_url}?pf_game_id=${pf_game_id}&_ts=${Math.round(new Date() / 1000)}`
          } else {
            game_url = `${game_url}&pf_game_id=${pf_game_id}&_ts=${Math.round(new Date() / 1000)}`
          }
          // 声明引入src
          let src = ''
          console.log(res.data)
          // 如果是微端
          if (urlParams.app === 'true') {
            src = FN.isIOS ? configUrl.__h5apiDomain.get("clientLoad") + 'clientIOS.js' + '?_cache=' + new Date().valueOf() : configUrl.__h5apiDomain.get("clientLoad") + 'clientAndroid.js' + '?_cache=' + new Date().valueOf()
          } else {
            // 如果是web端
            // use.js 地址不同于渠道融合的sdk，需要动态引入CDN
            // src = configUrl.__h5apiDomain.get("clientLoad") + channel + "/" + channel + "sdk.use.js" + `?_cache=${new Date().valueOf()}`;
            src = configUrl.__h5apiDomain.get("clientLoad") + channel + "/" + channel + "sdk.use.js" + `?_cache=${new Date().valueOf()}`;
          }

          this.setManifast(res.data)

          // channel_js = '//10.10.10.97:82/oversea_h5/oversea_h5sdk.js'
          // src = '//10.10.10.97:82/oversea_h5/oversea_h5sdk.use.js'
          // game_url = '//10.10.10.97:82/game.html'
          this.loadChannelJs(channel_js, () => {
            FN.inject("head", src, "script").then(() => {
              // 初始化游戏
              // 避免出现cp已经开始调用init，但是sdk中paramsLoad请求还未完成
              //let id = setInterval(() => {
              //     if (window.FUSE_CHANNEL_INFO.package_id) {
              //       this.src = game_url;
              //       clearInterval(id);
              //     }
              //   }, 500);
              let id = setInterval(() => {
                console.log('window.FUSE_CHANNEL_INFO.channel====================>', window.FUSE_CHANNEL_INFO.channel)
                if (window.FUSE_CHANNEL_INFO.channel) {
                  this.src = game_url;
                  clearInterval(id);
                }
              }, 500);
              // 加载iframe 的时候白屏，动画开始
              this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', {
                interfaceName: 'pageLoading'
              })
              document.getElementById("iframe").onload = () => {
                // 加载iframe完毕时候,动画结束
                this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
                this.getSetting()
              };
            })
          })
        }
      })
    },
    setManifast(data) {
      const gameId = data.app_id
      const headElem = document.createElement('head')
      const imgElem = document.createElement('img')
      imgElem.onload = () => {
        headElem.innerHTML = `<link rel="icon" type="image/png" sizes="32x32" href="/install/${gameId}/img/icons/favicon-32x32.png"><link rel="icon" type="image/png" sizes="16x16" href="/install/${gameId}/img/icons/favicon-16x16.png"><link rel="manifest" href="/install/${gameId}/manifest.json"><meta name="theme-color" content="#000000"><meta name="mobile-web-app-capable" content="yes"><meta name="apple-mobile-web-app-status-bar-style" content="default"><meta name="apple-mobile-web-app-title" content="${data.game_name}"><link rel="apple-touch-icon" href="/install/${gameId}/img/icons/apple-touch-icon-152x152.png"><link rel="mask-icon" href="/install/${gameId}/img/icons/safari-pinned-tab.svg" color="#000000"><meta name="msapplication-TileImage" content="/install/${gameId}/img/icons/msapplication-icon-144x144.png"><meta name="msapplication-TileColor" content="#000000">`
        document.querySelectorAll('head')[0].append(...headElem.children)
        if (FN.isIOS && FN.isSafari && window.navigator.standalone != undefined && !window.navigator.standalone) {
          FN.saveLocal('supportStand', 2)
        }
      }
      // imgElem.onerror = (err) => {
      //   console.log('fileElem err', err)
      // }
      imgElem.src = `/install/${gameId}/img/icons/favicon-16x16.png`
    },
    handleMessage(event) {
      // 根据上面制定的结构来解析iframe内部发回来的数据
      window.addEventListener(
        "message",
        event => {
          let data = event.data;
          if (data.type === "CC") {
            if (FN.getURLparams().app) {
              // 存储token, 用于发送给游戏方信息token
              console.log(data)
              this.$store.dispatch("SET_SDK_COMPONENT_TOKEN", data.token);
              CLIENTSDK[data.fn[0]](data.token, data.params[0])
            } else {
              // 网页端
              // console.log(data)
              if (data.fn) {
                JSSDK[data.fn[0]](data.token, data.params[0]);
              }
              // 存储token, 用于发送给游戏方信息token
              this.$store.dispatch("SET_SDK_COMPONENT_TOKEN", data.token);
            }
          }
        },
        false
      );
    },
    // 获取个人中心地址
    getSetting() {
      let {game_id, pf_game_id, package_id} = FN.getSession('FUSE_CHANNEL_INFO')
      window.MJFUSESDK.getSetting({game_id, pf_game_id, package_id}).then(res => {
        if (res.code === 0) {
          // console.log(res)
          FN.saveSession('SETTING_URLS', res.data)
          FN.saveLocal('SETTING_URLS', res.data)
        }
      })
      // 如果是ios就調用getCaid和getUtma
      if (FN.isIOS) {
        console.log('这里是进来获取getCaid')
        window.getCaid = function(str) {
          console.log('caid======>', str)
          FN.saveSession('caid', str.ca_id)
          FN.saveLocal('caid', str.ca_id)
        }
        window.getUtma = function(str) {
          console.log('utma======>', str)
          FN.saveSession('utma', str.ut_ma)
          FN.saveLocal('utma', str.ut_ma)
        }
        try {
          let message = {'method': 'getCaid'}
          window.webkit.messageHandlers.CLIENTSDK.postMessage(message)
          let data = {'method': 'getUtma'}
          window.webkit.messageHandlers.CLIENTSDK.postMessage(data)
        } catch (error) {

        }
      }
    },
    getInstallPrompt() {
      // if (window.BeforeInstallPromptEvent) {
      //   window.deferredPrompt = new window.BeforeInstallPromptEvent('beforeinstallpromptevent')
      //   FN.saveLocal('supportStand', 1)
      // }
      window.addEventListener('beforeinstallprompt', (event) => {
        // console.log('xxxxxxx beforeinstallprompt', event)
        // 阻止自动显示的提示
        event.preventDefault();
        // 可以在这里保存event以便之后使用
        window.deferredPrompt = event
        FN.saveLocal('supportStand', 1)
        // 可以在适当的时候显示你自己的安装提示
        // this.isShowInstall = true
      })
    },
  },
  mounted() {
    // this.iframeWin = this.$refs.iframe.contentWindow
    window.FUSE_CHANNEL_INFO = {
      channel: ''
    }
    this.getInstallPrompt()
    this.jsLoad()
    this.handleMessage(event)
    if (FN.getURLparams().isdebug) {
      FN.inject("head", 'https://cdn.jsdelivr.net/npm/vconsole@latest/dist/vconsole.min.js', "script").then(res => {
        var vConsole = new window.VConsole();
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-overflow-scrolling: touch;
  /* overflow-y: scroll; */
}
.main iframe {
  width: 100%;
  height: 100%;
  border: none;
}

</style>
